import type {
	Solution,
	CalculationConfiguration,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/solution/types';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';

export type { Solution } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/solution/types';

export const getIsSolutionLatest = (state: State): boolean => state.domain.solution.isLatest;

export const getIsSolutionValid = (state: State): boolean => state.domain.solution.isValid;

export const getSolution = (state: State): Solution => state.domain.solution;

export const getApplyingProgress = (state: State): number | null | undefined =>
	state.domain.solution.applyingProgress;

export const getCalculationConfiguration = (
	state: State,
): CalculationConfiguration | null | undefined => state.domain.solution.calculationConfiguration;
